import { Component, OnInit, Provider } from '@angular/core';
import { ProviderService, URLS } from 'src/app/constant/constant';
import { GraphqlService } from 'src/app/services/graphql.service';
import {
  name_input,
  address,
  city,
  phoneNumber,
  zipCode,
  textareaBox,
  dose_input,
  number_input
} from 'src/app/constant/constant';
import { CreateProviderKey } from 'src/app/models/provider';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { MessageService } from 'primeng/api';
import { API_PREFIX } from '../../../../shared/global';

@Component({
  selector: 'app-admin-api-keys',
  templateUrl: './admin-api-keys.component.html',
  styleUrls: [
    './admin-api-keys.component.css',
    '../../../../../assets/css/custom-egd.css'
  ],
  providers: [MessageService]
})
export class AdminApiKeysComponent implements OnInit {
  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  createDialog: boolean = false;
  createkey: CreateProviderKey = new CreateProviderKey();
  providerServices: any[] = [];
  submittedApiKeys: any[] = [];

  constructor(
    private readonly graphqlService: GraphqlService,
    private readonly providerStateService: ProviderStateService,
    private messageService: MessageService
  ) {}

  // for secondary dropdown
  tokenTypes: any[] = [];
  tokenValues: { [key: string]: string } = {};
  selectedKey: string = '';
  selectedProviderChosen: string = '';
  provider_id: string = '';
  providerSelected: boolean = false;
  webhookUrl = '';

  async ngOnInit() {
    this.provider_id = this.providerStateService.getProviderId();
    this.fetchSecretKeys();
    this.providerServices = Object.keys(ProviderService).map((key) => ({
      label: key,
      value: key
    }));
    this.webhookUrl = `${URLS.API_BASE_URL}${API_PREFIX}/stripe/webhook/${this.provider_id}`;
  }

  showDialogToAdd() {
    this.createDialog = true;
    this.resetForm();
  }

  Cancel() {
    this.createDialog = false;
    this.resetForm();
  }

  fetchSecretKeys() {
    this.graphqlService.fetchSecretNames().subscribe(
      (result) => {
        if (result && result.data) {
          this.submittedApiKeys = result.data['fetchSecretNames'];
        }
      },
      (error) => {
        console.error(
          'There was an error fetching the count from the API',
          error
        );
      }
    );
  }

  fetchServiceSources(event: any) {
    const selectedProvider = event.value;
    this.selectedProviderChosen = selectedProvider;
    this.providerSelected = !!selectedProvider;

    if (selectedProvider) {
      this.graphqlService
        .findProviderServiceTokenType(selectedProvider.value)
        .subscribe(
          (result) => {
            if (result && result.data && result.data) {
              this.tokenTypes = result.data['findProviderServiceTokenType'].map(
                (token) => ({
                  label: token.token_type,
                  value: token.id
                })
              );
              this.tokenValues = {};
              this.selectedKey = '';
            }
          },
          (error) => {
            console.error(
              'There was an error fetching the token types from the API',
              error
            );
          }
        );
    } else {
      console.error('No provider selected');
    }
  }

  isFormValid(): boolean {
    return this.tokenTypes.every((token) => this.tokenValues[token.value]);
  }

  OnSubmitAPIKeys() {
    if (!this.isFormValid()) {
      console.error('All fields are required');
      return;
    }

    const provider_id = this.provider_id;

    const submissionPromises = this.tokenTypes.map((token) => {
      const data = {
        provider_id: provider_id,
        provider_service_token_type_id: token.value,
        secret: this.tokenValues[token.value]
      };

      return this.graphqlService.addProviderSecret(data).toPromise();
    });

    Promise.all(submissionPromises)
      .then((responses) => {
        if (responses.every((response) => response)) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'API Keys added successfully'
          });

          // add submitted api keys to table
          this.submittedApiKeys.push(
            ...this.tokenTypes.map((token) => ({
              // provider: this.selectedProviderChosen,
              tokenType: token.label
              // apiKey: this.tokenValues[token.value]
            }))
          );

          this.createDialog = false;
          this.resetForm();
        } else {
          throw new Error('Some submissions failed');
        }
      })
      .catch((error) => {
        console.error('Error in mutation:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to add some or all API Keys'
        });
      });
  }

  deleteApiKey(apiKey: any) {
    this.submittedApiKeys = this.submittedApiKeys.filter(
      (key) => key !== apiKey
    );
  }

  resetForm() {
    this.selectedProviderChosen = '';
    this.tokenValues = {};
    this.tokenTypes = [];
    this.providerSelected = false;
  }

  isFormInvalid(): boolean {
    // Check if the provider service is selected
    if (!this.selectedProviderChosen) {
      return true;
    }

    // Check if all tokens have values
    for (let token of this.tokenTypes) {
      if (!this.tokenValues[token.value]) {
        return true;
      }
    }

    // If everything is valid, return false
    return false;
  }
}
